import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

const LAYER_BASE = 1;

export const Container = styled.div`
  gap: 36px;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-self: center;
  padding: 4px;
`;

export const SectionHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: 80%;
`;

export const SectionTitle = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const Spacer = styled.div`
  width: 100px;
`;

export const SectionDescription = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  text-overflow: clip;
  white-space: normal;
  max-width: 90%;
`;

export const SectionError = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) => props.theme.atlas.semantic.color.status.error.default};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CardGridContainer = styled.div`
  width: 80%;
`;

export const CardsGrid = styled.div`
  display: grid;
  row-gap: 24px;
  column-gap: 24px;
  align-self: stretch;
  grid-template-rows: fit-content(100%) minmax(0, 1fr);
  grid-template-columns: repeat(3, minmax(0, 1fr));
`;

export const QuestionnaireCard = styled.button<{ $selected: boolean }>`
  display: flex;
  height: 159px;
  min-width: 0;
  padding: 16px;
  flex-direction: column;
  border-radius: 6px;
  border: 1px solid;
  justify-content: space-between;
  ${(props) =>
    props.$selected
      ? props.theme.atlas.semantic.color.action.primary.hover
      : props.theme.atlas.semantic.color.outline.default};
  background-color: ${(props) =>
    props.$selected
      ? props.theme.atlas.semantic.color.action.secondary.hoverFill
      : props.theme.atlas.semantic.color.surface.default};
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    border-color: ${(props) =>
      props.theme.atlas.semantic.color.ui.loading.default};
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.action.secondary.hoverFill};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
    border-color: ${(props) =>
      props.theme.atlas.semantic.color.ui.divider.default};
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.subtle};
  }

  &:disabled:hover {
    border-color: ${(props) =>
      props.theme.atlas.semantic.color.ui.divider.default};
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.subtle};
  }
`;

export const CardTitle = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  font-weight: 600;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  text-align: left;
`;

export const CardDescription = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  width: 100%;
  min-width: 0;
  white-space: pre-wrap;
  text-align: left;
  max-height: 57px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const QuestionsContainers = styled.div`
  display: flex;
  width: 80%;
`;

export const QuestionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  width: 100%;
  min-width: 0;
  align-self: stretch;
`;

export const SubmitReportButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: ${LAYER_BASE};
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const SectionHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  justify-items: start;
  align-self: stretch;
`;

export const InformationBannerContainer = styled.div`
  width: 80%;
`;
